import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Auth, RegistryAuth } from '../models/auth';
import { Observable, BehaviorSubject, throwError, of } from 'rxjs';
import { GrantType } from '../shared/enums/grant-type.enum';
import { map } from 'rxjs/operators';
import { LocalStoreKeys } from '../shared/helpers/localstorage/local-store';
import { ResponseBase } from '../models/response-base';
import { Router } from '@angular/router';
import { AcessoRapidoService } from './acesso-rapido.service';
import { SpinnerVisibilityService } from 'ng-http-loader';
import { AssignorResponse } from '../models/cedente';
import { NewAlertService } from '../shared/components/new-alert/new-alert.service';
import { GatewayAuthService } from './gateway-auth.service';
import { ApiError } from '../shared/enums/api-error.enum';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  API: string = environment.API + 'Auth/';
  loginAPI: string = this.API + 'GetAccessPinWeb';
  pinAPI: string = this.API + 'GetAccessTokenWeb';
  registryAPI: string = this.API + 'GetRegistryTokenWeb';
  loginRegisteredAPI: string = this.API + 'GetRegisterAccessPin';

  assignorAPI: string = this.API + 'GetAssignorsWeb';

  private AUTHAPI = environment.AUTH_LOGIN;
  private AUTHAPI_REFRESH = environment.AUTH_REFRESH_TOKEN;

  private currentUserSubject: BehaviorSubject<Auth>;
  private currentUserRegistrySubject: BehaviorSubject<RegistryAuth>;
  public currentUser: Observable<Auth>;
  public currentUserRegistry: Observable<RegistryAuth>;

  constructor(
    private http: HttpClient,
    private router: Router,
    private alertService: NewAlertService,
    private acessoRapidoService: AcessoRapidoService,
    private spinner: SpinnerVisibilityService,
    private gatewayAuthService: GatewayAuthService) {

    this.currentUserSubject = new BehaviorSubject<Auth>(JSON.parse(localStorage.getItem(LocalStoreKeys.currentUser)));
    this.currentUser = this.currentUserSubject.asObservable();

    this.currentUserRegistrySubject = new BehaviorSubject<RegistryAuth>(JSON.parse(localStorage.getItem(LocalStoreKeys.currentUserRegistry)));
    this.currentUserRegistry = this.currentUserRegistrySubject.asObservable();
  }

  public get currentUserValue(): Auth {
    return this.currentUserSubject.value;
  }

  public get currentUserRegistryValue(): RegistryAuth {
    return this.currentUserRegistrySubject.value;
  }

  setCurrentUserValue(newCurrentUser: Auth) {
    localStorage.setItem(LocalStoreKeys.currentUser, JSON.stringify(newCurrentUser));
    this.currentUserSubject.next(newCurrentUser);
  }

  setCurrentUserRegistryValue(newCurrentUserRegistry: RegistryAuth) {
    localStorage.setItem(LocalStoreKeys.currentUserRegistry, JSON.stringify(newCurrentUserRegistry));
    this.currentUserRegistrySubject.next(newCurrentUserRegistry);
  }

  // reutilizar para enviar o userAssignorId
  login(documento: string, password: string, userAssignorId = null): Observable<ResponseBase<Auth>> {
    return this.http.post<ResponseBase<Auth>>(this.loginAPI, { documento, password, userAssignorId })
      .pipe(map(
        response => {

          this.gatewayAuthService.authenticate(documento, password).subscribe(
            response2 => {
              /* token */

              if (response2.status === -1) {
                response.status = ApiError.FalhaNaAutenticacao;
                response.message = 'Falha na autenticação do Gateway';
                response.result = null;
              } else {
                if (response.result) {
                  if (response.result.token.isAnonymous) {
                    response.result.token.isAnonymous = false;
                  }
                }

                if (userAssignorId) {
                  response.result.token.userAssignorId = userAssignorId;
                }
                localStorage.setItem(LocalStoreKeys.currentUser, JSON.stringify(response.result));
                this.currentUserSubject.next(response.result);
                this.gatewayAuthService.setCurrentUserValue(response2);
              }
            },
            () => {
                response.status = ApiError.FalhaNaAutenticacao;
                response.message = 'Falha na autenticação do Gateway';
                response.result = null;
            }
          );

          return response;
        }
      ));
  }

  logout(message?) {
    localStorage.clear();
    this.currentUserSubject.next(null);
    this.currentUserRegistrySubject.next(null);
    this.acessoRapidoService.clean();

    if (message !== null) {
      this.alertService.error(message, true);
    }

    this.router.navigate(['auth'], { state: { logout: true }});



    this.spinner.hide();
  }

  pin(documento: string, pin: string, grantType: GrantType, refreshToken: string, userAssignorId: string = null): Observable<ResponseBase<Auth>> {
    return this.http.post<ResponseBase<Auth>>(this.pinAPI, { pin, documento, grantType, refreshToken, userAssignorId })
      .pipe(map(
        response => {
          response.result.token.isAnonymous = false;

          if (userAssignorId) {
            response.result.token.userAssignorId = userAssignorId;
          }

          localStorage.setItem(LocalStoreKeys.currentUser, JSON.stringify(response.result));
          this.currentUserSubject.next(response.result);

          return response;
        }
      ));
  }

  assignors(documento: string, password: string, userReferenceId: string): Observable<ResponseBase<[AssignorResponse]>> {
    return this.http.post<ResponseBase<[AssignorResponse]>>(this.assignorAPI, { documento, password, userReferenceId });
  }

  registry(uuid: string, refreshToken: string, grantType: GrantType): Observable<ResponseBase<RegistryAuth>> {
    return this.http.post<ResponseBase<RegistryAuth>>(this.registryAPI, { webClientId: uuid, refreshToken, grantType });
  }

  loginRegistered(documento: string, password: string, userAssignorId = null): Observable<ResponseBase<Auth>> {
    return this.http.post<ResponseBase<Auth>>(this.loginRegisteredAPI, { documento, password, userAssignorId })
      .pipe(map(
        response => {
          if (response.result) {
            if(response.result.token != undefined)
                response.result.token.isAnonymous = false;
            else
                response.result.isAnonymous = false;
            // if (response.result.token.isAnonymous) {
            //   response.result.token.isAnonymous = false;
            // }
          }

          if (userAssignorId) {
            if(response.result.token != undefined)
                response.result.token.userAssignorId = userAssignorId;
            else
                response.result.userAssignorId = userAssignorId;
            //response.result.token.userAssignorId = userAssignorId;
          }

          /* localStorage.setItem(LocalStoreKeys.currentUser, JSON.stringify(response.result));
          this.currentUserSubject.next(response.result); */
          return response;
        }
      ));
  }

    newlogin(step: number, param1?: any, param2?: string, param3?: string, param4?: string): Observable<ResponseBase<Auth>>{
        const grantType = 'assignor_access';
        let body;
        //DOCUMENTO E SENHA
        if(step == 1){
            body = {userId: param1, password: param2, grantType };
        }
        //HASPIN (MAIS DE UMA CEDENTE)
        if(step == 2){
            body = {requestPin: param1, transitoryToken: param2, grantType }
        }
        //CONFIRMPIN (MAIS DE UMA CEDENTE)
        if(step == 3){
            body = {confirmationPin: param1, transitoryToken: param2, grantType }
        }
        return this.http.post<ResponseBase<Auth>>(this.AUTHAPI, body);
    }

    refreshToken(refreshToken: string){
        const grantType = 'refresh_token_assignor';
        return this.http.post<ResponseBase<Auth>>(this.AUTHAPI_REFRESH, {refreshToken, grantType});
    }

    getAssignorTransitoryToken(accessToken?: any): Observable<ResponseBase<Auth>>{
      const grantType = 'assignor_access';
      let body = { accessToken: accessToken, grantType }
      return this.http.post<ResponseBase<Auth>>(this.AUTHAPI, body);
    }
}
